export default __webpack_public_path__ + "static/media/remove.f12095a1.svg";